module.exports = __webpack_public_path__ + "static/mobile-screen-54a3dacd75343cbad4185af48d88845a.jpg";